import { render, staticRenderFns } from "./settlementPriceMain-import.vue?vue&type=template&id=22b0ef4c&scoped=true&"
import script from "./settlementPriceMain-import.vue?vue&type=script&lang=js&"
export * from "./settlementPriceMain-import.vue?vue&type=script&lang=js&"
import style0 from "./settlementPriceMain-import.vue?vue&type=style&index=0&id=22b0ef4c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0ef4c",
  null
  
)

export default component.exports